import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FlyoutOpeningData } from '../flyout-models';
import { FlyoutService } from '../flyout.service';
import { OnsiteCampaignType } from '../../campaign/campaign.model';
import { WidgetSimpleInfo } from '../../campaign/widgets.model';
import { WidgetService } from '../../shared/services/widget.service';

@Component({
  selector: 'app-flyout-widget-selector-filter',
  templateUrl: './flyout-widget-selector-filter.component.html',
  styleUrl: './flyout-widget-selector-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutWidgetSelectorFilterComponent implements OnInit {
  @Input() flyoutOpeningData: FlyoutOpeningData;

  private readonly flyoutService = inject(FlyoutService);
  private readonly widgetService = inject(WidgetService);

  public items: WidgetSimpleInfo[] = [];
  public readonly selectedControl = new FormControl<number[]>([]);
  public openCounts: Map<number, number> = new Map();
  public loading = true;
  public titleKey = '';
  public initialSelectedIds: number[] = [];

  ngOnInit(): void {
    this.titleKey = 'visits.criteriaProperties.' + (this.flyoutOpeningData?.widgetSelectorOptionName ?? '');
    this.initialSelectedIds = JSON.parse(JSON.stringify(this.flyoutOpeningData?.widgetSelectorSelectedIds ?? []));
    this.selectedControl.setValue(this.flyoutOpeningData?.widgetSelectorSelectedIds ?? []);

    const optionName = this.flyoutOpeningData?.widgetSelectorOptionName ?? '';

    this.widgetService.getAllWidgetsSimpleInfo().subscribe((widgets) => {
      this.items = this.filterByType(widgets ?? [], optionName);
      this.openCounts = new Map();
      this.loading = false;
    });
  }

  private filterByType(widgets: WidgetSimpleInfo[], optionName: string): WidgetSimpleInfo[] {
    if (optionName === 'widget-survey-response') {
      return widgets.filter((w) => w.campaignType === OnsiteCampaignType.Survey);
    } else if (optionName === 'widget-conversions') {
      // Surveys carry input fields too, but they log widget-survey-response instead of widget-conversion.
      return widgets.filter((w) => w.campaignType !== OnsiteCampaignType.Survey && w.hasInputFields);
    } else if (optionName === 'widget-clickthroughs') {
      return widgets.filter((w) => !w.hasInputFields);
    }
    return widgets;
  }
  public apply(): void {
    this.flyoutService.closeWidgetSelectorFlyout(this.selectedControl.value ?? []);
  }

  public cancel(): void {
    this.flyoutService.close();
  }
}
